import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { getInitials } from '@util/stringUtil'

import 'material-icons/iconfont/outlined.css'

import { Container, EditButton } from './styles'

const UserProfile = ({
  profile, children, size, onClick
}) => {
  return (
    <Container size={size} onClick={() => onClick()}>
      {getInitials(profile.name)}
      <EditButton className="material-icons-outlined">mode_edit_outline</EditButton>
      {children}
    </Container>
  )
}

UserProfile.propTypes = {
  profile: PropTypes.object.isRequired,
  children: PropTypes.node,
  size: PropTypes.number,
  onClick: PropTypes.func.isRequired,
}

UserProfile.defaultProps = {
  children: null,
  size: 40,
}

const mapStateToProps = ({ user }) => ({
  profile: user.profile,
})

export default connect(mapStateToProps, null)(UserProfile)
